export enum PatientNotesChannel {
  CREATE = 'patientNote::create',
  EDIT = 'patientNote::patch',
  DELETE = 'patientNote::delete',
}
